var shadowboardList = {
    id: -1,
    url:"",
    init: function () {
        this.deleteBoard();
        this.copyOrEditBoard();
    },
    deleteBoard: function()
    {
        $('.product-list').on('click', '.delete-shadowboard', function () {
            var id = $(this).data("id");
            $(this).parents("li").remove();
            $.ajax('/umbraco/api/Shadowboard/DeleteState', {
                data: { id: id },
                method: "GET",
            });
        });
    },
    copyOrEditBoard: function()
    {
       
        $('.product-list').on('click', ".edit-copy-click", function () {
            shadowboardList.id = $(this).data("id");
            shadowboardList.url = $(this).attr("href");
            $(".shadowboard-list-popup").show();
            return false;
        });

        $('.shadowboard-list-popup .icon-close').on('click', function () {
            $(".shadowboard-list-popup").hide();
            return false;
        });

        $('.shadowboard-list-popup .edit').on('click', function () {
            var win = window.open(shadowboardList.url, '_blank');
            win.focus();
            return false;
        });

        $('.shadowboard-list-popup .copy').on('click', function () {
            $.ajax('/umbraco/api/Shadowboard/Copy?id=' + shadowboardList.id, {
                method: "POST",
                async: false,
                success: function (response) {
                    var row = $('*[data-id="' + shadowboardList.id + '"]').first().parents("li");
                    var text = row.find(".list-product__name:first").text();
                    var newRow = row.html().replace(new RegExp(shadowboardList.id, 'g'), response);
                    newRow = newRow.replace(new RegExp(text, 'g'), text+"(Copy)");
                    $('.product-list__list li:eq(0)').after(newRow);
                    var url = $('.edit-copy-click[data-id="' + response + '"]').attr("href");
                    $(".shadowboard-list-popup").hide();
                    var win = window.open(url, '_blank');
                    win.focus();
                }
            })
            return false;
        });
      
    },
   
}
$(document).ready(function () {
    if ($(".page-product-basket--shadowboard-module").length > 0)
    {
        shadowboardList.init();
    }
});


